




























































import { Component, Prop, Watch } from 'vue-property-decorator';
import { IAgency, IRole, UserModel, UserRoleType } from 'admiral-core';
import { ArrowLeftIcon, ArrowRightIcon, PlusIcon, XIcon } from 'vue-feather-icons';
import { mixins } from 'vue-class-component';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormMixin } from '@/mixins/FormMixin';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import UserForm from '@/forms/UserForm.vue';
import { UserApi } from '@/services/UserApi';
import { BModal } from 'bootstrap-vue';
import { CALENDLY_LINK } from '@/constants';

@Component({
  components: {
    UserForm,
    FormSubmit,
    ArrowLeftIcon,
    ArrowRightIcon,
    PlusIcon,
    XIcon,
  },
})
export default class CreateUserModal extends mixins(FormMixin, BaseMixin) {
  model = this.defaultModel();

  @Prop({ required: true })
  selectedAgency!: IAgency;

  @Prop({ required: false, default: false })
  fromAdmin!: boolean;

  defaultModel(): UserModel {
    return {
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      agency: this.selectedAgency,
      group: '',
      emailText: '',
    };
  }

  async mounted() {
    this.resetModel();
  }

  @Watch('model.role', { immediate: true })
  onRoleChange() {
    if (this.model.role?.type) {
      this.model.emailText = this.emailTemplates(this.model.role?.type, {
        firstname: this.model.firstname || '',
        dashboardUrl: `https://${this.selectedAgency.identifier}.app.admiral-dashboard.de`,
        activationUrl: `https://${this.selectedAgency.identifier}.app.admiral-dashboard.de/bestaetigen`,
        calendlyUrl: CALENDLY_LINK,
      });
    }
  }

  @Watch('model.firstname')
  onFirstnameChange() {
    if (this.model.firstname) {
      this.model.emailText = this.emailTemplates(this.model.role?.type || UserRoleType.EMPLOYEE, {
        firstname: this.model.firstname || '',
        dashboardUrl: `https://${this.selectedAgency.identifier}.app.admiral-dashboard.de`,
        activationUrl: `https://${this.selectedAgency.identifier}.app.admiral-dashboard.de/bestaetigen`,
        calendlyUrl: CALENDLY_LINK,
      });
    }
  }

  async ok(evt: Event) {
    evt.preventDefault();
    try {
      this.isLoading = true;

      await UserApi.create({
        agency: this.selectedAgency,
        email: this.model.email!,
        firstname: this.model.firstname!,
        lastname: this.model.lastname!,
        role: this.model.role!,
        type: this.model.type!,
        group: this.model.group!,
        password: this.model.password,
        emailText: this.model.emailText || '',
      });
      this.$toastr.s(
        `${this.model.firstname} ${this.model.lastname} erfolgreich angelegt.`,
        'Mitarbeiter angelegt',
      );
      this.$nextTick(() => {
        (this.$refs['create-user'] as BModal).hide();
      });

      this.$emit('reload');
    } catch (e) {
      console.log(e);
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern des Mitarbeiters ist etwas schief gelaufen.', 'Oops');
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(
      apiErrors['firstnameminLength'],
      'firstname',
      'Bitte einen gültigen Vornamen angeben.',
    );

    this.addError(
      apiErrors['lastnameminLength'] || apiErrors['lastnameisNotEmpty'],
      'lastname',
      'Bitte einen gültigen Nachnamen angeben.',
    );

    this.addError(apiErrors['emailisEmail'], 'email', 'Bitte eine gültige E-Mail Adresse angeben.');

    this.addError(apiErrors['typeisNotEmpty'], 'type', 'Bitte eine Gruppe auswählen.');

    this.addError(
      apiErrors['UserAlreadyExists'],
      'email',
      'Es existiert bereits ein Mitarbeiter mit dieser E-Mail Adresse.',
    );
  }

  cancel() {
    this.resetModel();
  }

  resetModel() {
    this.model = this.defaultModel();
    this.model.role = this.roles.find((role: IRole) => role.type === UserRoleType.EMPLOYEE);
  }

  reload() {
    //
  }

  get isGuestUser() {
    return this.model.role?.type === UserRoleType.GUEST;
  }

  emailTemplates(
    roleType: UserRoleType,
    data: { firstname: string; dashboardUrl: string; activationUrl: string; calendlyUrl: string },
  ) {
    if (roleType === UserRoleType.ADMIN) {
      return `
Moin ${data.firstname},

wie schön, dass du dich für ADMIRAL entschieden hast – herzlich willkommen an Bord!
Ab sofort stehen dir alle Funktionen 14 Tage lang kostenlos zur Verfügung – Zeit, dein Vertriebspotenzial voll auszuschöpfen.

---

Hier geht’s direkt zu deinem persönlichen Dashboard:
👉 <a href="${data.dashboardUrl}">${data.dashboardUrl}</a>

🛡️ Bitte setze jetzt dein Passwort:
👉 <a href="${data.activationUrl}/{{code}}">${data.activationUrl}/{{code}}</a>

---

Das solltest du jetzt wissen:

✅ Du hast Fragen oder brauchst Hilfe?
Einfach im Dashboard oben rechts auf das Fragezeichen (?) klicken – dort erreichst du jederzeit unser Support-Team.

📅 Live-Onboarding gewünscht?
Sehr gern – buche dir hier deinen persönlichen Termin:
👉 <a href="${data.calendlyUrl}">${data.calendlyUrl}</a>

🔒 Sicherheit geht vor:
Deine Daten sind bei uns sicher. Wir setzen auf moderne Verschlüsselung und DSGVO-konforme Speicherung.

---

Wir freuen uns riesig, dich auf deinem Weg zu mehr Vertriebserfolg begleiten zu dürfen.
Mach dich bereit – denn:
#ADMIRALDashboard – #ErfolgIstPlanbar – #VertriebWarNieSoEinfach

Viel Spaß beim Entdecken & Testen!

Herzliche Grüße
Dein ADMIRAL-Team

      `.trim();
    }

    return '';
  }
}
